import { MuxPlayer, SectionWrapper } from '@portfolio/components'
import { SectionVideoPlayerProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { FC } from 'react'

const StyledSectionWrapper = styled(SectionWrapper, {
  display: 'grid',
  rowGap: '$20',
})

const Description = styled('p', {
  projectFont: 'body04',
  color: '$black_06',
})

export const SectionVideoPlayer: FC<SectionVideoPlayerProps> = ({
  video,
  description,
}) => {
  return (
    <StyledSectionWrapper type="RICH_TEXT_SM">
      {video && video.playbackId && (
        <MuxPlayer
          playbackId={video.playbackId}
          poster={video.firstFrame}
          isAutoPlay
          intersectionObserverOptions={{ rootMargin: '200px' }}
        />
      )}

      {description && (
        <div>
          <Description>↑ {description}</Description>
        </div>
      )}
    </StyledSectionWrapper>
  )
}
